import React from 'react'
import { Anchor, EditIcon, ExternalLinkIcon, Span, Tag } from '../../lib/components'
import { BLOG_CATEGORIES, BlogCategory, BlogStatus } from '../blogs-form/constants'
import { getFormattedDate } from '../../lib/utils/helpers'

export type BlogCardProps = {
  id: number
  bannerImage: string
  title: string
  subtitle: string
  content: string
  status: BlogStatus
  category: BlogCategory
  slug: string
  linkedinUrl: string
  createdAt: string
  updatedAt: string
  handleEditClick: (id: number) => void
}

export function BlogCard({
  id,
  bannerImage,
  title,
  subtitle,
  content,
  status,
  category,
  slug,
  linkedinUrl,
  createdAt,
  updatedAt,
  handleEditClick,
}: BlogCardProps) {
  // Helper functions.
  const formattedDate = (date: string) => getFormattedDate(new Date(date), 'D MMM YYYY [at] h:mm A')
  const textEllipsis = (text: string, maxLength: number) =>
    text.length > maxLength ? text.slice(0, maxLength) + '...' : text

  const categoryLabel = BLOG_CATEGORIES.find((c) => c.value === category)?.text ?? category

  return (
    <tr key={id}>
      <td>
        <img
          src={bannerImage}
          alt={title}
          className='w-100 h-100 object-fit-cover'
          loading='lazy'
          style={{
            borderRadius: '8px',
          }}
        />
      </td>
      <td>
        <Tag
          text={status}
          variant={status === 'DRAFT' ? 'white-bg' : status === 'ARCHIVED' ? 'black-bg' : 'gold-bg'}
        />
      </td>
      <td>{textEllipsis(title, 100)}</td>
      <td>{textEllipsis(subtitle, 100)}</td>
      <td> {textEllipsis(content, 100)} </td>
      <td style={{ color: '#caa566' }}> {categoryLabel} </td>
      <td> {textEllipsis(slug, 100)} </td>
      <td>
        {linkedinUrl ? (
          <a href={linkedinUrl} target='_blank' rel='noopener noreferrer'>
            {textEllipsis(linkedinUrl, 100)}
          </a>
        ) : (
          <Span variant='thin' text='N/A' />
        )}
      </td>
      <td> {formattedDate(createdAt)} </td>
      <td> {formattedDate(updatedAt)} </td>
      <td>
        <EditIcon
          classes={['align-center', 'pointer']}
          height='24'
          width='24'
          onClick={() => handleEditClick(id)}
          dataTestId='blog-list-card-edit-icon'
        />
      </td>
    </tr>
  )
}
